import { app } from '../../../app';
import { Controller } from './reseller.controller';

app.component('companyReseller', {
    bindings: {
        account: '<',
        appType$:'<',
        appTypes$:'<',
        companyId:'<',
    },
    controller: Controller,
    templateUrl: require('./reseller.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/reseller.component.js